export default {
	pageTitle: "My Commitments",

	//
	// components
	//

	// MyCommitments
	headerTitle: "My Action Items",

	// MyCommitmentsPlaceholder
	MyCommitmentsPlaceholder_title1: "Attempting to load your action items. Please wait.",
	MyCommitmentsPlaceholder_title2: "Looks like you don't have any action items yet.",
	MyCommitmentsPlaceholder_description: "Action items are tasks assigned to team members. You can create and assign action items while creating outcomes during your meetings.",

	// CommitmentsList
	CommitmentsList_noOutstandingCommitments: "You have no open action items.",
	CommitmentsList_showCompletedItemsButton: "Show completed items",
	CommitmentsList_loadMoreButton: "Load more",
	CommitmentsList_hideCompletedItemsButton: "Hide completed items",
};



// WEBPACK FOOTER //
// ./src/lang/en/myCommitments.js